module.exports = __webpack_public_path__ + "static/media/appliances4.a7bc3a41.jpg";